export const normalizeDataProtectionContent = value => {
  if (!value) {
    return '';
  }

  return String(value)
    .replaceAll(/<br\s*\/?>/gi, '\n')
    .replaceAll(/<\/p>\s*<p>/gi, '\n')
    .replaceAll(/<[^>]+>/g, '')
    .replaceAll('&nbsp;', ' ')
    .replaceAll('&amp;', '&')
    .replaceAll('&quot;', '"')
    .replaceAll('&#39;', "'")
    .trim();
};
